// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bg/XDL/types";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            position: relative;
        `,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        toggleTransition: {
            positionerCss: css`
                position: absolute;
            `,
            transitionCss: css`
                transition: none;
            `,
            timeout: {
                enter: 0,
                exit: 0,
            },
        },
        panelProps: {
            css: css`
                border: 0;
                padding: 7px 33px 7px 0;
                font-size: 16px;
            `,
        },
        titleTypographyProps: {
            css: css`
                font-weight: 500;
                color: ${getColor("text.main")};
                line-height: 20px;
                letter-spacing: 0.23px;
                font-size: 15px;
            `,
            size: 16,
        },
        toggleIconProps: {
            ...AccordionSectionPresentationPropsDefault?.toggleIconProps,
            color: "text",
        },
        collapseIconProps: {
            color: "tertiary",
        },
        headerProps: {
            css: css`
                background: none;
                button {
                    padding: 8px;
                    background: ${getColor("transparent")};
                    border: 0;
                    border-top: 1px solid ${getColor("common.ui9")} !important;
                    padding-left: 0;
                    outline: 0 !important;

                    &:focus {
                        border-width: 0 !important;
                        border-top-width: 1px !important;
                        padding: 8px;
                        padding-left: 0 !important;
                    }
                }
                button[aria-expanded="true"] {
                    svg {
                        color: ${getColor("tertiary")};
                    }
                }
                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    margin-top: 10px;
                }
            `,
        },
    },
} as xBaseTheme["accordion"];
